import script from "./CaseDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./CaseDetail.vue?vue&type=script&setup=true&lang=ts"

import "./CaseDetail.vue?vue&type=style&index=0&id=4696d558&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4696d558"]])

export default __exports__